// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1ZGYl","consentsList":"PatientConsents_consentsList__2fsDQ","consentsListEmpty":"PatientConsents_consentsListEmpty__3lnHS"};